import Vue from "vue";
import VueRouter from "vue-router";
import { Route } from "vue-router";
import store from "@/store";
import EtablissementsMain from "@/features/etablissements/main.vue";
import IndividusMain from "@/features/individus/main.vue";
import PointagesTempsMain from "@/features/pointages/pointages-temps/main.vue";
import PointagesHeureMain from "@/features/pointages/pointages-heure/main.vue";
import ActivitesMain from "@/features/activites/main.vue";
import ParametresMain from "@/features/parametres/main.vue";
import InformationMain from "@/features/information/main.vue";

const ROUTER_TRACE = "[ANMOBI][ROUTER]";
const traceRouter = (step: string, data?: any) => {
  const stamp = new Date().toISOString();
  if (typeof data === "undefined") {
    console.log(`${ROUTER_TRACE}[${stamp}] ${step}`);
    return;
  }
  console.log(`${ROUTER_TRACE}[${stamp}] ${step}`, data);
};
const traceRouterWarn = (step: string, data?: any) => {
  const stamp = new Date().toISOString();
  if (typeof data === "undefined") {
    console.warn(`${ROUTER_TRACE}[${stamp}] ${step}`);
    return;
  }
  console.warn(`${ROUTER_TRACE}[${stamp}] ${step}`, data);
};
const traceRouterError = (step: string, data?: any) => {
  const stamp = new Date().toISOString();
  if (typeof data === "undefined") {
    console.error(`${ROUTER_TRACE}[${stamp}] ${step}`);
    return;
  }
  console.error(`${ROUTER_TRACE}[${stamp}] ${step}`, data);
};

Vue.use(VueRouter);

const routes = [
  {
    name: "app",
    path: "/",
    component: () => import("@/App.vue"),
    meta: { redirectToHomeTimeout: 1 }

  },
  {
    name: "mock",
    path: "/mock",
    component: () => import("@/features/mock/main.vue"),
    meta: { redirectToHomeTimeout: 2000 }

  },
  {
    name: "home",
    path: "/home",
    component: () => import("@/features/home/main.vue"),
    meta: { authorize: ["user"], redirectToHomeTimeout: -1 }

  },
  {
    name: "opensession",
    path: "/session/open/:dossier?/:accesskey?",
    component: () => import("@/features/session/main.vue"),
    meta: { redirectToHomeTimeout: -1 }

  },
  {
    name: "register",
    path: "/session/register",
    component: () => import("@/features/session/register/main.vue")

  },
  {
    name: "sync",
    path: "/session/sync",
    component: () => import("@/features/session/sync/main.vue"),


  },
  {
    name: "logout",
    path: "/session/logout",
    component: () => import("@/features/session/main.vue"),
    meta: { authorize: ["user"], redirectToHomeTimeout: -1 }

  },
  {
    name: "parametres",
    path: "/parametres",
    component: ParametresMain,
    meta: { authorize: ["user"], redirectToHomeTimeout: -1 }

  },
  {
    name: "etablissements",
    path: "/etablissements",
    component: EtablissementsMain,
    meta: { authorize: ["user"], redirectToHomeTimeout: -1 }

  },
  {
    name: "activites",
    path: "/activites",
    component: ActivitesMain,
    meta: { authorize: ["user"], redirectToHomeTimeout: -1 }
  },

  {
    name: "Enfant-scan",
    path: "/scan",
    component: () => import("@/features/scan/main.vue"),
    meta: { authorize: ["user"], redirectToHomeTimeout: -1 }

  },
  {
    name: "ListIndividus",
    path: "/individus",
    component: IndividusMain,
    meta: { authorize: ["user"], redirectToHomeTimeout: -1 }

  },
  {
    name: "ListIndividusUrgence",
    path: "/list-urgence",
    component: () => import("@/features/individus/list-urgence.vue"),
    meta: { authorize: ["user"], redirectToHomeTimeout: -1 }

  },
  {
    name: "Information",
    path: "/information/:id",
    component: InformationMain,
    meta: { authorize: ["user"], redirectToHomeTimeout: -1 },
    props: true
  },
  {
    name: "schema-deverouillage",
    path: "/schema-deverouillage",
    component: () => import("@/features/schema-deverouillage/main.vue"),
    meta: { authorize: ["user"], redirectToHomeTimeout: -1 }

  },
  {
    name: "moncompte",
    path: "/moncompte",
    component: () => import("@/features/moncompte/main.vue"),
    meta: { authorize: ["user"], redirectToHomeTimeout: -1 }

  },
  // {
  //   name: "moncompteCode",
  //   path: "/moncompte/code",
  //   component: () => import("@/features/moncompte/moncompte-veille/main.vue"),
  //   meta: { authorize: ["user"], redirectToHomeTimeout: -1 }
  
  // },
  {
    name: "logoutuser",
    path: "/moncompte/logout",
    component: () => import("@/features/moncompte/logout.vue"),
    meta: { authorize: ["user"], redirectToHomeTimeout: -1 }

  },
  {
    name: "information-application",
    path: "/information-application",
    component: () => import("@/features/information-application/main.vue"),
    meta: { authorize: ["user"], redirectToHomeTimeout: -1 }

  },
  {
    name: "Pointages-temps",
    path: "/pointages/temps",
    component: PointagesTempsMain,
    meta: { authorize: ["user"], redirectToHomeTimeout: -1 }

  },
  {
    name: "Pointages-heure",
    path: "/pointages/heure",
    component: PointagesHeureMain,
    meta: { authorize: ["user"], redirectToHomeTimeout: -1 },
  },
  {
    name: "",
    path: "/erreurs",
    component: () => import("@/features/erreurs/main.vue"),
    children: [
      {
        path: "no-seances-found",
        component: () => import("@/features/erreurs/components/no-seance-found.vue")
      },
      {
        path: "palettes-not-found",
        component: () => import("@/features/erreurs/components/palettes-not-found.vue")
      },
      {
        path: "no-regime",
        component: () => import("@/features/erreurs/components/no-regime.vue")
      },
      {
        path: "no-individus-found",
        component: () => import("@/features/erreurs/components/no-individus-found.vue")
      },
      {
        path: "fail-pointage",
        component: () => import("@/features/erreurs/components/fail-pointage.vue")
      },
      {
        path: "no-previsionnel",
        component: () => import("@/features/erreurs/components/no-previsionnel.vue")
      },
      {
        path: "no-internet",
        component: () => import("@/features/erreurs/components/no-internet.vue")
      },
      {
        path: "access-denied",
        component: () => import("@/features/erreurs/components/access-denied.vue")
      },
      {
        path: "*",
        component: () => import("@/features/erreurs/components/default.vue")
      }

    ],
    meta: { authorize: ["user"], redirectToHomeTimeout: -1 },
  },
];


const router = new VueRouter({
  routes
});

router.onError((error: any) => {
  const message = error && error.message ? error.message : "";
  const isChunkLoadError = /ChunkLoadError|Loading chunk [\d]+ failed/i.test(message);

  traceRouterError("onError", {
    message,
    isChunkLoadError,
    currentPath: router.currentRoute && router.currentRoute.fullPath,
    online: navigator.onLine,
    href: window.location.href
  });

  if (!isChunkLoadError) {
    return;
  }

  traceRouterError("chunk-load-failed", error);

  if (navigator.onLine) {
    traceRouterWarn("chunk-load-failed-online-reload", { target: window.location.href });
    window.location.reload();
    return;
  }

  // Offline: ne JAMAIS forcer un redirect vers /session/open.
  // On garde l'écran courant et on loggue le contexte.
  traceRouterWarn("chunk-load-failed-offline-stay-on-current-route", {
    currentPath: router.currentRoute && router.currentRoute.fullPath
  });
});

router.beforeEach((to, from, next) => {
  traceRouter("beforeEach", {
    from: from.fullPath,
    to: to.fullPath,
    routeName: to.name,
    requiresAuth: !!to.meta.authorize,
    isAuthenticated: store.getters.isAuthenticated,
    online: navigator.onLine
  });
  const { authorize } = to.meta;
  if (authorize && !store.getters.isAuthenticated) {
    traceRouterWarn("beforeEach:not-authenticated-redirect", { to: to.fullPath, redirect: "/session/register" });
    next({ path: "/session/register", query: { returnUrl: to.path } });
  } else {

    next();

  }
});

router.afterEach((to, from) => {
  traceRouter("afterEach", {
    from: from.fullPath,
    to: to.fullPath,
    routeName: to.name,
    online: navigator.onLine
  });
});

window.addEventListener("offline", () => {
  traceRouterWarn("browser-offline", {
    currentPath: router.currentRoute && router.currentRoute.fullPath,
    href: window.location.href
  });
});

window.addEventListener("online", () => {
  traceRouter("browser-online", {
    currentPath: router.currentRoute && router.currentRoute.fullPath,
    href: window.location.href
  });
});


export default router;
